// Horizontal status filter tabs above the members table - no counts, underline style (Figma layout)
import React from 'react';

const tabItems = [
  { value: 'all', label: 'All Members' },
  { value: 'onboard', label: 'Onboard' },
  { value: 'onLeave', label: 'On Leave' },
  { value: 'pending', label: 'Pending' },
];

const CrewStatusTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="tw-flex tw-overflow-x-auto tw-gap-6 tw-border-b tw-border-gray-100 tw-text-sm">
      {tabItems.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onTabChange(tab.value)}
          className={[
            'tw-pb-3 tw-font-medium tw-transition-colors tw-whitespace-nowrap tw-bg-transparent tw-border-0 tw-cursor-pointer tw-px-0',
            activeTab === tab.value
              ? 'tw-text-indigo-600 tw-border-b-2 tw-border-indigo-600'
              : 'tw-text-gray-500 hover:tw-text-gray-700',
          ].join(' ')}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default CrewStatusTabs;
